import { FC } from 'react';

import './index.sass';

const VerticalLine: FC = () => <div className='straight-line' />;

export default VerticalLine;
